import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

import { benefitApi } from "@api";
import {
    BenefitEmpty,
    ComponentBenefitItem,
    ComponentBenefitList,
    IconAppliEvi,
    IConArrowUp,
    IconCakeEvi,
    IConClose,
    IconTelEvi,
    ModuleEmpty,
} from "@components";
import { enumStatus, enumTypes } from "@configs";
import { IBenefit, IMembershipTier, IPagination } from "@interfaces";
import { fetchUser, selectApp, selectAuth, selectMerchant, setLoading } from "@redux";
import UIStore from "@Rocket-Innovation/components/store/useUIStore";
import { formatMessage, RenderMeta, useNotify } from "@utils";
import { Skeleton } from "antd";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";
import { SuccessIcon } from "src/Components/icon/SuccessIcon";
import CountdownTimer from "src/Components/shared/CountDownTimer";
import { Pending } from "src/Components/shared/Pending";
import PopupProcessingFail from "src/Components/shared/PopupProcessingFail";
import PopupPrecessingProgress from "src/Components/shared/PopupProcessingProgress";
import PopupWarning from "src/Components/shared/PopupWarning";
import { Redeemed } from "src/Components/shared/Redeemed";
import { Used } from "src/Components/shared/Used";
import { formatDateNumber, formatDateStartEnd } from "src/Utils/dateUtil";

export const ModulesBenefit = () => {
    //page hooks

    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { langSetting } = useSelector(selectApp);
    const { error, success, warning } = useNotify();
    const { userInfo } = useSelector(selectAuth);
    //page state
    const [benefit, setBenefit] = useState<IBenefit[]>([]);
    const [loadingPagination, setLoadingPagination] = useState<boolean>(false);
    const [param, setParam] = useState<IPagination>({
        page: 1,
        limit: 100,
    });
    const [spinning, setSpinning] = useState<boolean>(false);
    const [isShowPopup, setShowPopup] = useState<boolean>(false);
    const [focusCoupon, setFocusCoupon] = useState<any>();
    const [cNote, setCNote] = useState<string>("");
    const [aCode, setACode] = useState<string>("");
    const [redeemDetail, setRedeemDetail] = useState<any>();
    const isConfirm = true;
    const [showEvidence, setShowEvidence] = useState<boolean>(false);
    const [userDetail, setUserDetail] = useState<any>(null);
    const [showpage1, setShowPage1] = useState(true);
    const [showpage4, setShowPage4] = useState(false);
    const [showresult, setShowResult] = useState(false);
    const [showpopuppage, setShowPopupPage] = useState(true);
    const [isWarning, setIsWarning] = useState<boolean>(false);
    const [warningMessage, setWarningMessage] = useState<string>("");
    const [amountRedeem, setAmountRedeem] = useState<number>(1);
    const [popupConfirmSuccess, setPopupConfirmSuccess] = useState(false);
    const [resultMessage, setResultMessage] = useState<any>([]);
    const [isProcessing, setIsProcessing] = useState<boolean>(false);
    const [itemFail, setItemFail] = useState<any[]>([]);
    const [isProcessingFail, setIsProcessingFail] = useState<boolean>(false);
    const [countItems, setCountItem] = useState<number>(0);

    useEffect(() => {
        (async () => {
            setSpinning(true);
            try {
                const res = await benefitApi.getListBenefit(param);
                const data = res.data as IBenefit[];
                setBenefit(data);
            } finally {
                setSpinning(false);
            }
        })();
    }, []);

    // useEffect(() => {
    //     setShowPopup(true);
    //     setShowPopupPage(true);
    //     setShowResult(true);
    // }, []);

    const handleCloseDetail = () => {
        setShowPopup(false);
        closeAllPopup();
    };

    const handleCloseWarning = () => {
        setIsWarning(false);
    };

    const handleClick = (id: string) => {
        // history.push(PATH_BENEFIT + "/" + id);
        useBenefit(id);
    };

    const useBenefit = async (id: string) => {
        dispatch(setLoading(true));
        const res = await benefitApi.getDetailBenefitById(id);
        setACode(res.data.alienCodeTxts);
        setFocusCoupon(res.data);
        setShowPopup(true);

        dispatch(setLoading(false));
    };

    const handleLoadMore = async () => {
        const paramPanigation = {
            ...param,
            page: (param.page || 1) + 1,
        };
        setParam(paramPanigation);
        setLoadingPagination(true);
        const res = await benefitApi.getListBenefit(paramPanigation);
        const data = res.data as IBenefit[];
        setBenefit([...benefit, ...data]);
        setLoadingPagination(false);
    };

    const loadingComponent = (
        <StyledSkeleton>
            <Skeleton
                loading={true}
                avatar
                active
                title={true}
                paragraph={{ rows: 2, width: [113, 113] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                avatar
                active
                title={true}
                paragraph={{ rows: 2, width: [113, 113] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                avatar
                active
                title={true}
                paragraph={{ rows: 2, width: [113, 113] }}
            ></Skeleton>
            <Skeleton
                loading={true}
                avatar
                active
                title={true}
                paragraph={{ rows: 2, width: [113, 113] }}
            ></Skeleton>
        </StyledSkeleton>
    );

    const closeAllPopup = () => {
        setShowPage1(true);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(true);
    };

    const handleCopyClick = () => {
        navigator.clipboard
            .writeText(focusCoupon?.alienCode)
            .then(() => {
                console.log("Text successfully copied to clipboard!");
            })
            .catch((err) => {
                console.error("Error copying text to clipboard:", err);
            });
    };

    // const onFinalRedeem = async () => {
    //     UIStore.setState({ isLoading: true });
    //     try {
    //         let res = await benefitApi.redeemed({
    //             objectId: focusCoupon?._id,
    //             status: enumStatus.ACTIVE,
    //             type: enumTypes.BENEFIT,
    //         });
    //         let msg = res?.data?.message.split("||");
    //         if (res.status === 201) {
    //             setRedeemDetail(res.data.benefit);
    //             if (langSetting?.language === "ENGLISH") {
    //                 success(msg[1] || "");
    //             } else {
    //                 success(msg[0] || "");
    //             }
    //             setUserDetail(res?.data?.userDetails);
    //             setShowPage4(false);
    //             setShowResult(true);
    //             setShowPopupPage(true);
    //             setACode(res?.data?.benefit?.alienCode);
    //             setParam({
    //                 page: 1,
    //                 limit: 50,
    //             });
    //             const beneRes = await benefitApi.getListBenefit({
    //                 page: 1,
    //                 limit: 50,
    //             });
    //             const data = beneRes.data as IBenefit[];
    //             setBenefit(data);
    //         }
    //         dispatch(fetchUser());

    //         UIStore.setState({ isLoading: false });
    //     } catch (err: any) {
    //         // error(formatMessage(err.response));
    //         setWarningMessage(formatMessage(err.response));
    //         UIStore.setState({ isLoading: false });
    //         handleCloseDetail();
    //         setIsWarning(true);
    //     }
    // };

    const onFinalRedeem = async () => {
        if (amountRedeem === 1) {
            UIStore.setState({ isLoading: true });
            try {
                let res = await benefitApi.redeemed({
                    objectId: focusCoupon?._id,
                    status: enumStatus.ACTIVE,
                    type: enumTypes.BENEFIT,
                });
                let msg = res?.data?.message.split("||");
                if (res.status === 201) {
                    setRedeemDetail(res.data.benefit);
                    if (langSetting?.language === "ENGLISH") {
                        success(msg[1] || "");
                    } else {
                        success(msg[0] || "");
                    }
                    setUserDetail(res?.data?.userDetails);
                    setShowPage4(false);
                    setShowResult(true);
                    setShowPopupPage(true);
                    setACode(res?.data?.benefit?.alienCode);
                    setParam({
                        page: 1,
                        limit: 50,
                    });
                    const beneRes = await benefitApi.getListBenefit({
                        page: 1,
                        limit: 50,
                    });
                    const data = beneRes.data as IBenefit[];
                    setBenefit(data);
                }
                dispatch(fetchUser());

                UIStore.setState({ isLoading: false });
            } catch (err: any) {
                // error(formatMessage(err.response));
                setWarningMessage(formatMessage(err.response));
                UIStore.setState({ isLoading: false });
                handleCloseDetail();
                setIsWarning(true);
            }
        } else {
            // สร้าง array ของ promises สำหรับการเรียก API 2 ตัวในแต่ละรอบ

            setShowPage4(false);
            setShowResult(false);
            setShowPopup(false);
            setShowPopupPage(false);
            setIsProcessing(true);
            let loopCount = 0;
            const results: any = await Array.from({ length: amountRedeem })?.reduce(
                async (prevPromise, _, i) => {
                    const acc: any = await prevPromise;
                    loopCount = i + 1; // ✅ นับรอบปัจจุบัน (เริ่มจาก 1)
                    if (i === 0) {
                        setCountItem(loopCount);
                    } else if (i < amountRedeem - 1) {
                        setCountItem(loopCount);
                    }
                    try {
                        let redeemRes = await benefitApi.redeemed({
                            objectId: focusCoupon?._id,
                            status: enumStatus.ACTIVE,
                            type: enumTypes.BENEFIT,
                        });

                        acc.push({ success: true, response: redeemRes, index: i + 1 });
                    } catch (error) {
                        acc.push({ success: false, error, index: i + 1 });
                    }
                    await new Promise((resolve) => setTimeout(resolve, 500));

                    if (loopCount === amountRedeem) {
                        setCountItem(amountRedeem);
                    }
                    return acc;
                },
                Promise.resolve([] as any[])
            );

            console.log("results", results);
            // ประมวลผลทุกผลลัพธ์
            const successResults: any = [];
            const errorResults: any = [];

            results.forEach((result: any) => {
                if (result.success) {
                    const res = result.response;
                    successResults.push({
                        index: result.index,
                        benefit: res?.data?.benefit,
                        alienCode: res?.data?.benefit?.alienCode,
                        shippingAddress: res?.data?.benefit?.shippingAddress,
                        points: res?.data?.benefit?.points,
                    });
                } else {
                    const msg: any = result.error.response?.data?.message.split("||");

                    errorResults.push({
                        index: result.index,
                        error: langSetting?.language === "ENGLISH" ? msg[1] : msg[0],
                    });
                }
            });

            // แสดงผลตามจำนวนที่สำเร็จ
            if (successResults.length > 0) {
                await new Promise((resolve) => setTimeout(resolve, 1000));
                setIsProcessing(false);
                const successMessage =
                    langSetting?.language === "ENGLISH"
                        ? `${focusCoupon?.name} x ${successResults.length}`
                        : `${focusCoupon?.name} x ${successResults.length}`;
                if (errorResults.length > 0) {
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                    setItemFail(errorResults);
                    setIsProcessingFail(true);
                    setResultMessage((prev: any) => [...prev, successMessage]);
                } else {
                    await new Promise((resolve) => setTimeout(resolve, 1000));
                    setPopupConfirmSuccess(true);
                    setRedeemDetail(successResults[0].benefit);
                    setACode(successResults[0].alienCode);
                    setResultMessage((prev: any) => [...prev, successMessage]);
                }
            } else {
                await new Promise((resolve) => setTimeout(resolve, 1000));
                setIsProcessing(false);
                setWarningMessage(errorResults[0]?.error);
                handleCloseDetail();
                setIsWarning(true);
            }
            // return ผลลัพธ์ทั้งหมด
            return {
                success: successResults,
                errors: errorResults,
                total: amountRedeem,
                successCount: successResults.length,
                errorCount: errorResults.length,
            };
        }
    };

    const closeConfirmSuccess = () => {
        setPopupConfirmSuccess(false);
        setShowPage1(false);
        setShowPage4(false);
        setShowResult(false);
        setShowPopupPage(false);
        setShowPopup(false);
        setResultMessage([]);
        dispatch(fetchUser());
        setItemFail([]);
        setCountItem(0);
        setIsProcessingFail(false);
        setIsProcessing(false);
    };
    const checkBenefit = () => {
        setPopupConfirmSuccess(false);
        // dispatch(setNavigationType(4));
        // window.location.href = "/privilege/history";
        setShowPopup(false);
        setResultMessage([]);
        dispatch(fetchUser());
        setItemFail([]);
        setCountItem(0);
        setIsProcessingFail(false);
        setIsProcessing(false);
        history.push("/privilege/history");
    };

    const handleCloseProcessing = () => {
        setIsProcessing(false);
    };

    const handleCloseProcessingFail = () => {
        setIsProcessingFail(false);
        setItemFail([]);
        setPopupConfirmSuccess(true);
    };

    console.log("showpage1", showpage1);
    console.log("showpage4", showpage4);

    console.log("showresult", showresult);

    console.log("showpopuppage", showpopuppage);
    console.log("showEvidence", showEvidence);
    console.log("isShowPopup", isShowPopup);

    return (
        <>
            <RenderMeta title={t("meta.benefit_list")} />
            {!spinning ? (
                benefit?.length > 0 ? (
                    <ComponentBenefitList
                        data={benefit}
                        loadingPagination={loadingPagination}
                        handleLoadMore={handleLoadMore}
                        handleClick={handleClick}
                    />
                ) : (
                    <div style={{ height: "500px" }}>
                        <StyledEmptyLayout>
                            <ModuleEmpty
                                description={t("page.no_benefit")}
                                image={<BenefitEmpty />}
                            />
                        </StyledEmptyLayout>
                    </div>
                )
            ) : (
                loadingComponent
                // <ComponentSpinPage children={loadingComponent} />
                // null
            )}
            {isShowPopup && (
                <StyledShowPopup isConfirm={isConfirm} themeColor={themes?.themeColor!}>
                    <div className="page-wrapper">
                        <div className="close" onClick={handleCloseDetail}>
                            <IConClose width={16} />
                        </div>
                        {showpopuppage ? (
                            <div className="content-layout">
                                <div className="content">
                                    {showpage1 ? (
                                        <>
                                            <div className="header-product">
                                                <div className="layout-img">
                                                    <div className="img-product">
                                                        <img src={focusCoupon?.imageUrl[0]} />
                                                    </div>
                                                </div>
                                                <div className="topic-product">
                                                    {focusCoupon?.name}
                                                </div>
                                                {/* <div className="total-point-product">
                                                    Total 300 Rewards
                                                </div> */}
                                            </div>
                                            <div className="content-product">
                                                {focusCoupon?.description ? (
                                                    <>
                                                        <div className="topic-detail">
                                                            {t("page.conditions")}
                                                        </div>
                                                        <div
                                                            className="control-text"
                                                            dangerouslySetInnerHTML={{
                                                                __html: focusCoupon?.description,
                                                            }}
                                                        ></div>
                                                    </>
                                                ) : null}
                                            </div>
                                            <StyledAmountRedeem>
                                                <span className="text-amount">
                                                    {"Amount Redeem"}
                                                </span>
                                                {/* {amountRedeem > checkAmountQuotaLimit?.total && (
                                                    <p className="text-over-limit">
                                                        {"**Reward usage limit exceeded"}
                                                    </p>
                                                )} */}
                                                <div className="button-action">
                                                    <span
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            let amount = Number(amountRedeem) - 1;
                                                            if (amount <= 1) {
                                                                amount = 1;
                                                            }
                                                            setAmountRedeem(amount);
                                                        }}
                                                    >
                                                        <img src="../images/icon/circle-delete.svg" />
                                                    </span>
                                                    <span className="amount">{amountRedeem}</span>
                                                    <span
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() => {
                                                            let amount = Number(amountRedeem) + 1;
                                                            // if (amount >= 100) {
                                                            //     amount = 100;
                                                            // }
                                                            setAmountRedeem(amount);
                                                        }}
                                                    >
                                                        <img src="../images/icon/circle-add.svg" />
                                                    </span>
                                                </div>
                                            </StyledAmountRedeem>
                                            <StyledUsedBtn
                                                className="btn-redeem"
                                                themeColor={themes?.themeColor!}
                                                onClick={() => {
                                                    setShowPage1(false);
                                                    setShowPage4(true);
                                                    setShowPopupPage(false);
                                                }}
                                            >
                                                {t("page.redeem")}
                                            </StyledUsedBtn>
                                        </>
                                    ) : null}

                                    {showresult ? (
                                        <>
                                            <div className="content-info">
                                                <div className="header-product">
                                                    <div className="layout-img">
                                                        <div className="img-product">
                                                            <img
                                                                src={
                                                                    focusCoupon
                                                                        ? focusCoupon?.imageUrl[0]
                                                                        : ""
                                                                }
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="topic-product">
                                                        {focusCoupon?.name}
                                                    </div>
                                                    {/* <div className="total-point-product">
                                                        100 left
                                                    </div> */}
                                                    {/* <div className="point-product">
                                                        <span><Points size={16} /></span>{focusCoupon.point}
                                                    </div> */}
                                                    <div className="expier-product">
                                                        {t("page.exp")} :{" "}
                                                        {formatDateStartEnd(
                                                            focusCoupon.startDate,
                                                            focusCoupon.endDate
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            {focusCoupon?.autoUseTime?.enabled && (
                                                <div className="countdownBox">
                                                    <CountdownTimer
                                                        targetDate={redeemDetail?.autoUseTimeOut}
                                                    />
                                                    <div style={{ textAlign: "center" }}>
                                                        The code will expire{" "}
                                                        {focusCoupon?.autoUseTime?.time}{" "}
                                                        {focusCoupon?.autoUseTime?.timeUnit === "s"
                                                            ? "seconds "
                                                            : focusCoupon?.autoUseTime?.timeUnit ===
                                                              "m"
                                                            ? "minutes "
                                                            : focusCoupon?.autoUseTime?.timeUnit ===
                                                              "h"
                                                            ? "hours "
                                                            : " "}
                                                        after clicking the confirm button.
                                                    </div>
                                                </div>
                                            )}
                                            <div className="action-layout">
                                                <div className="qr-layout">
                                                    <div className="qr-box">
                                                        <QRCode
                                                            value={
                                                                aCode
                                                                    ? aCode
                                                                    : redeemDetail?.ticketCode || ""
                                                            }
                                                            size={150}
                                                        />
                                                    </div>
                                                    {focusCoupon && (
                                                        <StyledCodeButton
                                                            mainColor={themes?.themeColor!}
                                                        >
                                                            {aCode || redeemDetail?.ticketCode}
                                                        </StyledCodeButton>
                                                    )}
                                                </div>
                                                {focusCoupon?.alienCode ||
                                                    (aCode !== "" && (
                                                        <StyledAlienCode
                                                            mainColor={themes?.themeColor!}
                                                        >
                                                            <div className="title text-normal-bold">
                                                                {t("page.benefitCode")}
                                                            </div>
                                                            <div className="alien-code-btn">
                                                                {focusCoupon?.alienCode || aCode}
                                                                <span onClick={handleCopyClick}>
                                                                    <img
                                                                        src="../images/ic-copy.png"
                                                                        alt=""
                                                                    />
                                                                </span>
                                                            </div>
                                                            <div className="custom-barcode">
                                                                <Barcode
                                                                    value={
                                                                        focusCoupon?.alienCode ||
                                                                        aCode
                                                                    }
                                                                />
                                                            </div>
                                                        </StyledAlienCode>
                                                    ))}
                                                {/* <StyledAlienCode mainColor={themes?.themeColor!}>
                                                    <div className="custom-barcode">
                                                        <Barcode value={testAcode} />
                                                    </div>
                                                    <div className="alien-code-btn">
                                                        {testAcode}
                                                        <span onClick={handleCopyClick}><img src="../images/ic-copy.png" alt="" /></span>
                                                    </div>
                                                </StyledAlienCode> */}
                                                {/* <p className="code-qr">{focusCoupon.code}</p> */}
                                                {focusCoupon?.notiStatus === "REDEEMED" ? (
                                                    <p className="redeemed-product">
                                                        <span className="redeemed">
                                                            <Redeemed color="#336C51" />
                                                        </span>
                                                        {focusCoupon?.notiStatus}
                                                    </p>
                                                ) : null}
                                                {focusCoupon?.notiStatus === "PENDING" ? (
                                                    <p className="pending-product">
                                                        <span className="pending">
                                                            <Pending color="#ED773A" />
                                                        </span>
                                                        {focusCoupon?.notiStatus}
                                                    </p>
                                                ) : null}
                                                {focusCoupon?.notiStatus === "USED" ? (
                                                    <p className="used-product">
                                                        <span className="used">
                                                            <Used color="#336C51" />
                                                        </span>
                                                        {focusCoupon?.notiStatus}
                                                    </p>
                                                ) : null}
                                                <p className="note">
                                                    {focusCoupon?.noticeText
                                                        ? focusCoupon?.noticeText
                                                        : t("page.desConfirm")}
                                                </p>
                                            </div>
                                        </>
                                    ) : null}
                                </div>
                                {showresult && (
                                    <div className="user-detail">
                                        <div className="icon-up">
                                            <IConArrowUp />
                                        </div>
                                        <div className="user-section">
                                            <div className="top-user">
                                                <div className="img-name">
                                                    <div className="profile-img">
                                                        <img
                                                            src={
                                                                userInfo?.avatar ||
                                                                "../images/img-profile-default-01.png"
                                                            }
                                                            alt="imgprofile"
                                                        />
                                                    </div>
                                                    <div className="profile-name">
                                                        <div className="name">
                                                            {merchant?.advanceSettings?.tier
                                                                ?.isFullName
                                                                ? userInfo?.contact?.fullName
                                                                : userInfo?.contact?.firstName +
                                                                  " " +
                                                                  userInfo?.contact?.lastName}
                                                        </div>
                                                        <div className="tell-date">
                                                            <span>
                                                                <IconTelEvi />{" "}
                                                                {userInfo?.phoneNumber}
                                                            </span>
                                                            <span>
                                                                <IconCakeEvi />{" "}
                                                                {userInfo?.contact?.dateOfBirth
                                                                    ? formatDateNumber(
                                                                          userInfo?.contact
                                                                              ?.dateOfBirth
                                                                      )
                                                                    : "-"}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="tier">
                                                    <img
                                                        src={
                                                            userDetail?.memberTypeNameIcon ||
                                                            "../images/gray.jpg"
                                                        }
                                                        alt="imgprofile"
                                                    />
                                                    <p>{userDetail?.memberTypeName}</p>
                                                </div>
                                            </div>
                                            {userDetail?.memberTypeImage?.[0] && (
                                                <div
                                                    className="view-img-btn"
                                                    onClick={() => setShowEvidence(true)}
                                                >
                                                    <IconAppliEvi /> Application evidence
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : null}
                        {showpage4 ? (
                            <StyledPopupRedeem
                                isConfirm={isConfirm}
                                themeColor={themes?.themeColor!}
                            >
                                <div className="box-popupconfirm">
                                    <div className="img-popupconfirm">
                                        <img
                                            src={
                                                merchant?.themes?.basicThemeSetting?.iconGeneral[0]
                                                    ?.image
                                            }
                                            alt=""
                                        />
                                    </div>
                                    <div className="title">
                                        <div className="text-sub-header">
                                            {t("page.pleaseconfirm")}
                                        </div>
                                        {focusCoupon?.autoUseTime?.enabled ? (
                                            <div className="text-desc">
                                                The code will expire in{" "}
                                                {focusCoupon?.autoUseTime?.time}{" "}
                                                {focusCoupon?.autoUseTime?.timeUnit === "s"
                                                    ? "seconds "
                                                    : focusCoupon?.autoUseTime?.timeUnit === "m"
                                                    ? "minutes "
                                                    : focusCoupon?.autoUseTime?.timeUnit === "h"
                                                    ? "hours "
                                                    : " "}
                                                confirmation.
                                            </div>
                                        ) : null}
                                    </div>
                                    <div className="btn-popupconfirm">
                                        <StyledUsedBtn
                                            className="btn-cancel"
                                            themeColor={themes?.themeColor!}
                                            onClick={() => {
                                                setShowPage4(false);
                                                setShowPage1(true);
                                                setShowPopupPage(true);
                                            }}
                                        >
                                            {t("page.cancel")}
                                        </StyledUsedBtn>
                                        <StyledUsedBtn
                                            className="btn-redeem"
                                            themeColor={themes?.themeColor!}
                                            // onClick={() => { setShowPage4(false); setShowResult(true); setShowPopupPage(true); }}
                                            onClick={onFinalRedeem}
                                        >
                                            {t("page.confirm")}
                                        </StyledUsedBtn>
                                    </div>
                                </div>
                            </StyledPopupRedeem>
                        ) : null}
                    </div>
                </StyledShowPopup>
            )}
            {popupConfirmSuccess ? (
                <StyledPopupRedeem isConfirm={isConfirm} themeColor={themes?.themeColor!}>
                    <div className="box-popupconfirm">
                        <span
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                marginTop: "-30px",
                                paddingBottom: "22px",
                            }}
                        >
                            <SuccessIcon />
                        </span>
                        <div className="title" style={{ paddingBottom: "10px" }}>
                            <div className="text-sub-header">
                                {"Benefit redeemed successfully!"}
                            </div>
                            <div
                                className="text-desc"
                                style={{ fontSize: "14px", lineHeight: "30px", color: "#000" }}
                            >
                                {resultMessage?.map((item: string, index: number) => (
                                    <span key={index}>{item}</span>
                                ))}
                            </div>
                            <div
                                className="text-desc"
                                style={{ fontSize: "14px", color: "#9B9B9B" }}
                            >
                                {"You can find it in your redemption history."}
                            </div>
                        </div>

                        <div className="btn-popupconfirm">
                            <StyledUsedBtn
                                className="btn-cancel"
                                themeColor={themes?.themeColor!}
                                onClick={() => closeConfirmSuccess()}
                            >
                                {t("page.cancel")}
                            </StyledUsedBtn>
                            <StyledUsedBtn
                                className="btn-redeem"
                                themeColor={themes?.themeColor!}
                                onClick={() => checkBenefit()}
                            >
                                {"Check benefit"}
                            </StyledUsedBtn>
                        </div>
                    </div>
                </StyledPopupRedeem>
            ) : null}
            {showEvidence && (
                <StyledDrawer themeColor={themes?.themeColor!}>
                    <div className="content-layout">
                        <div className="content">
                            <div className="header">
                                <div className="header-name">Application evidence</div>
                                <div className="close" onClick={() => setShowEvidence(false)}>
                                    <IConClose />
                                </div>
                            </div>
                            <div className="input-section">
                                <div className="evi-img">
                                    <img
                                        src={
                                            userDetail?.memberTypeImage?.[0] || "../images/gray.jpg"
                                        }
                                        alt="imgprofile"
                                    />
                                </div>
                                {/* <div className="date-tag">
                                    <IconDateEvi /> Date Verification: 20/12/2566
                                </div> */}
                            </div>
                        </div>
                    </div>
                </StyledDrawer>
            )}
            {isWarning && <PopupWarning onClose={handleCloseWarning} text={warningMessage} />}
            {isProcessing && (
                <PopupPrecessingProgress
                    onClose={handleCloseProcessing}
                    text={"Please wait a moment, we are processing redeem your reward"}
                    countItem={countItems}
                    amount={amountRedeem}
                />
            )}
            {isProcessingFail && (
                <PopupProcessingFail
                    onClose={handleCloseProcessingFail}
                    text={`Processing fail ${itemFail?.length || 0} items, please try again`}
                    listFail={itemFail}
                />
            )}
        </>
    );
};

interface IProps {
    data: IBenefit;
    handleClick: (id: string) => void;
}

export const ModulesBenefitItem = (props: IProps) => {
    //page props
    const { data, handleClick } = props;
    //redux state
    const { memberShipTiers } = useSelector(selectMerchant);
    //page state
    const [dataRanks, setDataRanks] = useState<IMembershipTier[]>([]);
    //page variable
    const levelIds = data.levelIds;

    useEffect(() => {
        if (levelIds.length === 0) {
            setDataRanks(memberShipTiers || []);
        } else {
            levelIds.forEach((item) => {
                //
                const check = memberShipTiers?.findIndex((value) => value._id === item) || 0;
                if (check >= 0 && memberShipTiers) {
                    dataRanks.push(memberShipTiers[check]);
                }
            });
            setDataRanks([...dataRanks]);
        }
    }, []);

    return (
        <>
            <ComponentBenefitItem data={data} handleClick={handleClick} dataRanks={dataRanks} />
        </>
    );
};

const StyledSkeleton = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    padding: 12px;
    .ant-skeleton {
        display: flex;
        width: 100%;
        flex-direction: column;
        .ant-skeleton-header {
            padding-right: 0;
            span {
                width: 100%;
                height: 167px;
                border-radius: 14px;
            }
        }
        .ant-skeleton-title {
            width: 100% !important;
            height: 10px;
            border-radius: 4px;
        }
        .ant-skeleton-paragraph {
            margin-top: 0 !important;
            li {
                height: 10px;
                border-radius: 4px;
                &:last-child {
                    margin-top: 15px;
                }
            }
        }
    }
`;

const StyledPopupRedeem = styled.div<{ isConfirm: boolean; themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 65px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupconfirm {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                max-width: 150px;
                width: 100%;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: ${(p) => p.themeColor};
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        flex-direction: column;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
        }
        .text-desc {
            font-size: 11px;
            color: #000;
            font-weight: 400;
        }
    }
`;

const StyledCodeButton = styled.div<{ mainColor?: string }>`
    position: absolute;
    background: ${(p) => p.mainColor};
    border-radius: 80px;
    height: 26px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    bottom: 0;
    padding: 8px 12px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #ffffff;
`;

const StyledAlienCode = styled.div<{ mainColor?: string }>`
    display: flex;
    align-items: center;
    column-gap: 10px;
    flex-direction: column;
    margin-bottom: 10px;
    .title {
        margin-bottom: 10px;
    }
    .alien-code-btn {
        color: #c4a363;
        margin-bottom: 16px;
        font-size: 20px;
        font-weight: 500;
        margin: 0;
        width: 100%;
        text-align: center;
        padding: 18px 0;
        background-color: #ddd;
        border-radius: 12px;
        background-image: url(../../images/bg-code.svg);
        background-size: cover;
        position: relative;
        span {
            position: absolute;
            right: 15px;
            top: 50%;
            z-index: 1;
            transform: translateY(-50%);
            img {
                width: 20px;
            }
        }
    }
`;

const StyledShowPopup = styled.div<{ isConfirm: boolean; themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;
        .close {
            position: absolute;
            left: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            color: ${(p) => p.themeColor};
            background-color: #336c51;
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: auto;
        min-height: 80dvh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        padding-top: 24px;
        /* padding-bottom: 24px; */
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .content {
            background: transparent !important;
        }
        .user-detail {
            background-color: ${(p) => p.themeColor}20;
            // height: 130px;
            // position: fixed;
            bottom: 0;
            width: 100%;
            border-radius: 15px 15px 0 0;
            padding: 10px 10px 20px;
            .icon-up {
                text-align: center;
            }
            .user-section {
                border: 1px solid ${(p) => p.themeColor};
                width: 100%;
                border-radius: 8px;
                .top-user {
                    padding: 10px;
                    display: flex;
                    justify-content: space-between;
                    .img-name {
                        display: flex;
                        .profile-img {
                            width: 40px;
                            height: 40px;
                            margin-right: 15px;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                border-radius: 100%;
                                border: 1px solid #fff;
                            }
                        }
                        .profile-name {
                            .name {
                                font-size: 16px;
                                line-height: 1.8em;
                                font-weight: 600;
                            }
                            .tell-date {
                                font-size: 12px;
                                span {
                                    margin-right: 15px;
                                }
                            }
                        }
                    }
                    .tier {
                        text-align: center;
                        img {
                            width: 30px;
                            height: 30px;
                            /* width: 100%; */
                            /* height: 100%; */
                            object-fit: cover;
                            border-radius: 100%;
                            border: 1px solid #fff;
                        }
                        p {
                            margin: 0;
                            font-size: 12px;
                        }
                    }
                }

                .view-img-btn {
                    text-align: center;
                    background-color: ${(p) => p.themeColor};
                    border-radius: 0 0 8px 8px;
                    padding: 3px;
                    color: white;
                }
            }
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            // margin-bottom: 20px;
            margin-top: -100px;
            padding-bottom: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            margin-bottom: 50px;
            .topic-detail {
                text-align: center;
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .control-text {
                max-height: 150px;
                overflow: scroll;
                width: 100%;
                word-break: break-all;
            }
            ul {
                li {
                    font-size: 12px;
                    line-height: 16px;
                    color: #9b9b9b;
                }
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            padding: 10px;
        }
        .countdownBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            // padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            height: 43dvh;
            overflow: scroll;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;
const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledLoading = styled.div`
    margin-top: 25px;
    padding: 0 24px;
    .card {
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 1px 3px 6px rgba(0, 0, 0, 0.23);
        margin-bottom: 28px;
        background-color: ${(p) => p.theme.colors.card};
        display: flex;
        width: 100%;
        position: relative;
        .img {
            width: 170px;
            height: 170px;
            @media (max-width: 375px) {
                width: 130px;
                height: 130px;
            }
        }
        .content {
            flex: 1;
            .title {
                margin: 14px 20px 14px 20px;
            }
            .content {
                margin: 0 20px;
            }
        }
    }
`;
const StyledEmptyLayout = styled.div`
    .ant-empty-description {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        text-align: center;
        color: #a5a5a5;
    }
`;

const StyledDrawer = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        .header-name {
            color: ${(p) => p.themeColor};
            font-size: 18px;
            font-weight: 600;
        }
    }
    .content {
        width: 480px;
        max-width: 100vw;
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px 16px 0 0;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .input-section {
            padding: 0px 20px;
            padding-bottom: 20px;
            color: ${(p) => p.themeColor};
            .evi-img {
                width: 100%;
                height: auto;
                overflow: scroll;
                max-height: 50dvh;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 15px;
                }
            }
            .date-tag {
                text-align: center;
                background-color: ${(p) => p.themeColor};
                color: white;
                padding: 10px;
                width: 80%;
                border-radius: 50px;
                margin-left: auto;
                margin-right: auto;
                margin-top: -20px;
                position: relative;
                z-index: 2;
            }
        }
    }
`;

const StyledAmountRedeem = styled.div`
    display: flex;
    padding: 12px 0px 2rem;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    .text-amount {
        align-self: stretch;
        color: #9b9b9b;
        text-align: center;
        font-size: var(--Size-1sm, 12px);
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 166.667% */
        padding-bottom: 10px;
    }
    .text-over-limit {
        align-self: stretch;
        color: #e53223;
        text-align: center;
        font-size: var(--Size-2xs, 11px);
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding-bottom: 10px;
        margin-top: -16px;
    }
    .button-action {
        display: flex;
        align-items: center;
        gap: 8px;
        .amount {
            width: 36px;
            color: #000;
            text-align: center;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
`;
